/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { ControlledCustomSelect } from "../../../components/formsComponents";
import { api } from "../../../api/api";
import {
    IDrivedExternalLeadStatus,
} from "../../../redux/external-leads/external-leads-life-cycle/external-lead-status.types";
import { useBillingCompanyContext } from "../../../providers";


export interface IExtLeadStatusFilterProps {
    value: string[];
    onChange: (value: string[]) => void;
    isHighlighted?: boolean;
    extraOptions?: { label: string; value: string }[];
}

export const ExtLeadStatusFilter: React.FC<IExtLeadStatusFilterProps> = (
    props,
) => {
    const {
        value,
        isHighlighted,
        onChange,
        extraOptions = [],
    } = props;
    const companyOutlet = useBillingCompanyContext();
    const [options, setOptions] = React.useState<readonly IDrivedExternalLeadStatus[]>([]);


    const fetchSuggestion = async () => {
        try {
            const res = await api.get(
                `/dataManagement/get-drive-external-status?company_outlet_uuid=${companyOutlet.comapny.company_outlet_uuid}`,
            );
            const data: IDrivedExternalLeadStatus[] = res.data.data || [];
            const mappedData = data.map((status) => ({
                ...status,
                drive_status_uuid: status.external_status_uuid,
            }));
            setOptions(mappedData);
        } catch (error) {
            console.error("Error fetching external lead status list:", error);
        }
    };

    useEffect(() => {
        fetchSuggestion()
    }, [])


    return (
        <>
            <ControlledCustomSelect
                label="Status"
                labelId="ext-lead-status"
                fullWidth
                clearable={value.length > 0}
                sx={{
                    minWidth: "120px",
                    ...(isHighlighted && {
                        backgroundColor: "#fff2c7",
                        borderRadius: 1,
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "warning.main",
                            borderWidth: "2px !important",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "warning.main",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "warning.main",
                        },
                    }),
                }}
                multiple
                displayEmpty
                value={value}
                options={[
                    ...extraOptions,
                    ...options.map((opt) => ({ label: opt.name, value: opt.name })),
                ]}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            // Row spacing/scrollbar come from the shared default
                            // in ControlledCustomSelect. Only add the static
                            // "ALL" option styling here: italic + muted with a
                            // divider below (matches the Handled By sentinel).
                            "& .MuiMenuItem-root:first-of-type": {
                                fontStyle: "italic",
                                color: "text.secondary",
                                borderBottom: (t) => `1px solid ${t.palette.divider}`,
                            },
                        },
                    },
                }}
                onChange={(e) => onChange(e.target.value as string[])}
                onClear={() => (
                    // Clearing keeps "ALL" ticked (no status filter applied).
                    onChange(["ALL"])
                )}
            />
        </>
    );
};
